import { useRef } from 'react';

import { Divider } from '@material-ui/core';

import PropTypes from 'prop-types';
import useSWR from 'swr';

import { Section, SectionAlternate } from '@/src/components/organisms';
import { scroller } from '@/src/lib/utils';

import {
  About,
  Articles,
  Features,
  Hero,
  Sales,
  Partners,
  Solutions,
  Categories,
} from './components';
import { features, mobileapp, categories } from './data';

const PlatformView = ({ themeMode }) => {
  const platformRef = useRef();

  const scrollToRef = ref => setTimeout(() => scroller(ref.current.offsetTop - 200), 500);

  const { data: partners } = useSWR('/commons/cms/institutions/');

  return (
    <div>
      <Hero themeMode={themeMode} onLearnMore={() => scrollToRef(platformRef)} />
      <Section>
        <div ref={platformRef}>
          <Features data={features} />
        </div>
      </Section>
      <About />
      <SectionAlternate>
        <Categories data={categories} />
      </SectionAlternate>
      <Section>
        <Sales data={mobileapp} />
      </Section>
      <Solutions />
      <SectionAlternate>
        <Articles />
      </SectionAlternate>
      <Divider />
      <Section>
        <Partners institutions={partners} />
      </Section>
    </div>
  );
};

PlatformView.propTypes = {
  /**
   * Theme mode
   */
  themeMode: PropTypes.string,
};

export default PlatformView;
